module.exports = __webpack_public_path__ + "img/what3words-alt.3227cb69.svg";